<template>
	<div class="search-user-machine-group">
		<div class="el-search vue-top-padding radius">
			<div class="el-left">
				<el-button
					type="primary"
					v-hasPerm="['user:machine:group:insert']"
					size="small"
					icon="el-icon-plus"
					@click="addUserMachineGroup"
					style="margin: 0;"
					>{{ $t("common.add") }}</el-button
				>
			</div>
			<div class="el-right">
				<el-form
					ref="userMachineGroup"
					:model="search"
					:inline="true"
					label-width="10px"
					size="small"
					class="demo-form-inline el-input-height"
				>
					<el-form-item prop="teamName" style="margin: 0 10px 0 0;">
						<el-input
							v-model="search.teamName"
							:placeholder="$t('searchUserMachineGroup.name')"
							@input="onSubmit"
						></el-input>
					</el-form-item>
					<el-form-item style="margin: 0;">
						<el-button type="primary" @click="onSubmit" icon="el-icon-search">{{
							$t("common.search")
						}}</el-button>
						<el-button
							@click="resetSearch('userMachineGroup')"
							icon="el-icon-refresh"
							>{{ $t("common.reset") }}</el-button
						>
					</el-form-item>
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "SearchUserMachineGroup",
	props: {
		search: Object,
	},
	data() {
		return {};
	},
	methods: {
		onSubmit() {
			this.$emit("onSubmit", this.search);
		},
		resetSearch(formName) {
			this.$refs[formName].resetFields();
			this.$toolUtil.clearForm(this.search);
			this.$emit("resetSearch", this.search);
		},
		addUserMachineGroup() {
			this.$emit("addUserMachineGroup");
		},
	},
};
</script>

<style scoped></style>
